module.exports = __webpack_public_path__ + "img/10.437d0cfd.jpg";